module.exports = __webpack_public_path__ + "img/cover.46c524af.jpg";